import { Language } from "../../graphql/generated/graphql";
import { prepareLanguagesForFormik } from "../../utils";
import { FormValues } from "./types";

export const defaultForms: FormValues[] = [
  {
    translations: {
      create: prepareLanguagesForFormik(
        { title: "سابقه کاری" },
        [{ lang: Language.Fa, title: "سابقه کاری" }],
        [Language.Fa]
      ),
    },
    criterias: {
      create: [
        {
          required: true,
          commentable: true,
          translations: {
            create: prepareLanguagesForFormik(
              { title: "سابقه کاری" },
              [{ lang: Language.Fa, title: "سابقه کاری" }],
              [Language.Fa]
            ),
          },
        },
      ],
    },
  },
  {
    translations: {
      create: prepareLanguagesForFormik(
        { title: "ظاهر مناسب" },
        [{ lang: Language.Fa, title: "ظاهر مناسب" }],
        [Language.Fa]
      ),
    },
    criterias: {
      create: [
        {
          required: true,
          commentable: true,
          translations: {
            create: prepareLanguagesForFormik(
              { title: "ظاهر مناسب" },
              [{ lang: Language.Fa, title: "ظاهر مناسب" }],
              [Language.Fa]
            ),
          },
        },
      ],
    },
  },
  {
    translations: {
      create: prepareLanguagesForFormik(
        { title: "مصاحبه تلفنی" },
        [{ lang: Language.Fa, title: "مصاحبه تلفنی" }],
        [Language.Fa]
      ),
    },
    criterias: {
      create: [
        {
          required: true,
          commentable: true,
          translations: {
            create: prepareLanguagesForFormik(
              { title: "مصاحبه تلفنی" },
              [{ lang: Language.Fa, title: "مصاحبه تلفنی" }],
              [Language.Fa]
            ),
          },
        },
      ],
    },
  },
  {
    translations: {
      create: prepareLanguagesForFormik(
        { title: "مصاحبه حضوری" },
        [{ lang: Language.Fa, title: "مصاحبه حضوری" }],
        [Language.Fa]
      ),
    },
    criterias: {
      create: [
        {
          required: true,
          commentable: true,
          translations: {
            create: prepareLanguagesForFormik(
              { title: "مصاحبه حضوری" },
              [{ lang: Language.Fa, title: "مصاحبه حضوری" }],
              [Language.Fa]
            ),
          },
        },
      ],
    },
  },
];
